import React from 'react';
import { TemplateProps } from 'src/components-dummy/types';

export const CustomCell = ({ children }: TemplateProps): JSX.Element => {
  return <>{children}</>;
};
